import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, CanDeactivate } from '@angular/router';
import { ApplicationService } from '@app/shared/application/application.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RlaService } from './rla.service';
import { AppComponentBase } from '@shared/common/app-component-base';

@Injectable()
export class RlaGuard implements CanActivate, CanDeactivate<AppComponentBase> {

    constructor(
        private rlaService: RlaService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
       return this.rlaService.getRla(this.applicationService.caseId).pipe(
            map(() => true)
        );
    }

    canDeactivate(component: AppComponentBase): boolean | Observable<boolean> {
        this.rlaService.closeRla();
        return true;
    }
}
